import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Discount } from '@open-tender/types'
import {
  fetchDeals,
  selectBrand,
  selectContent,
  selectCustomer,
  selectDeals,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  Content,
  HeaderDefault,
  Loading,
  Main,
  PageContainer,
  PageContent,
  PageError,
  PageTitle,
  Reward,
  Rewards,
} from 'components'

const Deals = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { title: siteTitle, has_deals } = useAppSelector(selectBrand) || {}
  const { deals: config } = useAppSelector(selectContent) || {}
  const { profile } = useAppSelector(selectCustomer)
  const { customer_id } = profile || {}
  const { entities: deals, loading, error } = useAppSelector(selectDeals)
  const hasDeals = deals.length > 0
  const isLoading = loading === 'pending'

  const renderItem = useCallback(
    ({ item }: { item: Discount }) => <Reward item={item} isDeal />,
    []
  )

  useEffect(() => {
    if (!has_deals) return navigate('/account')
  }, [has_deals, navigate])

  useEffect(() => {
    dispatch(fetchDeals())
  }, [dispatch, customer_id])

  return (
    <>
      <Helmet>
        <title>
          {config?.title} | {siteTitle}
        </title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer>
            <PageTitle {...config} />
            {error ? (
              <PageError error={error} />
            ) : (
              <PageContent style={{ maxWidth: '99rem' }}>
                {hasDeals ? (
                  <Rewards rewards={deals} renderItem={renderItem} />
                ) : isLoading ? (
                  <Loading text="Retrieving today's deals..." />
                ) : (
                  <p>
                    We're not featuring any deals today. Please check back soon!
                  </p>
                )}
              </PageContent>
            )}
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default Deals
